import type { FC } from 'react';
import React from 'react';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { TextDesktop } from '@alfa-bank/site-text-v2/desktop';
import { ButtonDesktop } from '@alfa-bank/site-button-v2/desktop';

import type { TComponentDesktop } from '../models';
import { DeliverySlotDate } from '../../delivery-slot-date/component';
import { DeliverySlotTimeComponent } from '../../delivery-slot-time/component';
import { DeliverySlotsError } from '../../delivery-slots-error';
import { useDeliverySlotsDesktop } from '../hooks/use-delivery-slots';

export const DeliverySlotsDesktop: FC<TComponentDesktop> = ({
    analytics,
    availableDates,
    disabled,
}) => {
    const { handleOnSelectDate, handleOnSelectTime, selectedDateData } = useDeliverySlotsDesktop({
        analytics,
        availableDates,
    });

    return (
        <>
            <Block notPadded styler={{ marginBottom: 24 }}>
                {availableDates.map(item => (
                    <DeliverySlotDate
                        key={item.date}
                        Button={ButtonDesktop}
                        dateISO={item.date}
                        disabled={disabled}
                        onSelect={handleOnSelectDate}
                        Text={TextDesktop}
                    />
                ))}
            </Block>
            {selectedDateData && (
                <Block notPadded>
                    {selectedDateData.intervals.map(item => (
                        <DeliverySlotTimeComponent
                            key={`${selectedDateData.date}-${item.slotFrom}-${item.slotTo}`}
                            Button={ButtonDesktop}
                            disabled={disabled}
                            onSelect={handleOnSelectTime}
                            slotData={item}
                            Text={TextDesktop}
                        />
                    ))}
                </Block>
            )}
            <DeliverySlotsError Text={TextDesktop} />
        </>
    );
};
